import React from 'react';
import {
  SaveButton,
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
} from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';

import { createPluralizedMessage } from '../../../core/utils/index';
import messages from '../../../core/i18n/englishLanguageMessages';

import AddExistingOrphanFundForm from './AddExistingOrphanFundForm';
import DialogTitleWithCloseButton from '../../../core/components/DialogTitleWithCloseButton';
import FundFamilyApi from '../../../core/apis/FundFamilyApi';
import { getIcError } from '../../../core/providers/utils';

class AddExistingOrphanFundDialog extends React.Component {
  fundFormProps;

  state = {
    submitting: false
  };

  setFundFormProps = props => {
    this.fundFormProps = props;
  };

  handleSaveClick = event => {
    // Trigger a submit of our custom quick create/update form
    // This is needed because our modal action buttons are oustide the form
    this.fundFormProps.form.submit(event);
  };

  handleClose = () => {
    const { handleDialogToggle } = this.props;
    const { submitting } = this.state;
    if (submitting) return;
    this.fundFormProps.form.reset();
    handleDialogToggle();
  };

  handleSubmit = values => {
    const {
      fundFamilyId,
      fetchStart,
      fetchEnd,
      showNotification,
      handleDialogToggle,
      refreshView
    } = this.props;

    this.setState({ submitting: true });

    // Dispatch an action letting react-admin know a API call is ongoing
    fetchStart();

    // Use the new fundRelationship API to link funds to fund family
    const resultOperation = FundFamilyApi.linkFundsToFundFamily(
      fundFamilyId,
      values.funds
    );

    resultOperation
      .then(() => {
        refreshView();
        handleDialogToggle();
        showNotification(
          createPluralizedMessage(
            messages.ra.notification.updated,
            values.funds.length
          )
        );
      })
      .catch(error => {
        showNotification('ra.notification.server', 'error', {
          messageArgs: { message: getIcError(error) }
        });
      })
      .finally(() => {
        // Dispatch an action letting react-admin know a API call has ended
        this.fundFormProps.form.reset();
        fetchEnd();
        this.setState({ submitting: false });
      });
  };

  render() {
    const { showDialog } = this.props;
    const { submitting } = this.state;

    return (
      <Dialog
        fullWidth
        open={showDialog}
        aria-label={`Create fund`}
        maxWidth="md"
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return null;
          this.handleClose();
        }}
      >
        <DialogTitleWithCloseButton onClose={this.handleClose}>
          {'Add Existing Fund to Fund Family'}
        </DialogTitleWithCloseButton>
        <DialogContent>
          <AddExistingOrphanFundForm
            {...this.props}
            setFundFormProps={this.setFundFormProps}
            handleSubmit={this.handleSubmit}
          />
        </DialogContent>
        <DialogActions>
          <SaveButton
            saving={submitting}
            handleSubmitWithRedirect={this.handleSaveClick}
            label={'Add'}
            icon={<></>}
          />
          <Button
            onClick={this.handleClose}
            variant="outlined"
            color="primary"
            disabled={submitting}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
};

export default connect(null, mapDispatchToProps)(AddExistingOrphanFundDialog);
